<template>
    <div>
        <Breadcrumbs main="Admin" submain="" title="Dashboard" />
        <!-- Container-fluid starts-->
        <div class="container-fluid"> 
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <div style="width: 100%;" v-if="!loading && !error">
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-4 card-col">
                                        <router-link to="/resources/monitoring-data" class="stat-card stat-card--centered">
                                            <div class="title">Monitoring Data
                                                <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4 card-col">
                                        <router-link to="/resources/asset/list" class="stat-card">
                                            <div class="title">Asset
                                                <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                            </div>
                                            <div class="count" v-if="asset_count.count >= 0">{{ asset_count.count }}</div>
                                        </router-link>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4 card-col">
                                        <router-link to="/volunteer/list" class="stat-card">
                                            <div class="title">Volunteer
                                                <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                            </div>
                                            <div class="count" v-if="volunteer_count.total_volunteers >= 0">{{ volunteer_count.total_volunteers }}</div>
                                        </router-link>
                                    </div>
                                </div>

                                <p class="mt-4 main-title">Asset ({{ asset_count.count }})</p>
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-xl-3 card-col">
                                        <div class="stat-card">
                                            <div class="title">Active</div>
                                            <div class="count" v-if="asset_count.active >= 0">{{ asset_count.active }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-xl-3 card-col">
                                        <div class="stat-card">
                                            <div class="title">Under Maintenance</div>
                                            <div class="count" v-if="asset_count.maintenance >= 0">{{ asset_count.maintenance }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-xl-3 card-col">
                                        <div class="stat-card">
                                            <div class="title">Approval Pending</div>
                                            <div class="count" v-if="asset_count.approval >= 0">{{ asset_count.approval }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-xl-3 card-col">
                                        <div class="stat-card">
                                            <div class="title">Inactive</div>
                                            <div class="count" v-if="asset_count.inactive >= 0">{{ asset_count.inactive }}</div>
                                        </div>
                                    </div>
                                </div>

                                <p class="mt-4 main-title">Volunteer ({{ volunteer_count.total_volunteers }})</p>
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-xl-3 card-col" v-for="vol_count, index in volunteer_count.data" :key="index">
                                        <div class="stat-card">
                                            <div class="title">{{ vol_count.name }}</div>
                                            <div class="count" v-if="vol_count.volunteer_count >= 0">{{ vol_count.volunteer_count }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <loader/>
                            </div>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
    
<script>
    import { mapState } from 'vuex';
    import loader from '../loader/loader.vue';

    export default {
        components: {
            loader
        },
    
        data() {
            return { }
        },
    
        computed: {
            ...mapState({
                asset_count: state => state.dashboard.asset_count,
                volunteer_count :state => state.dashboard.volunteer_count,
                loading: state => state.dashboard.dashboardCountLoading,
                error: state => state.dashboard.dashboardCountError
            })
        },
    
        mounted() {
            this.$store.dispatch("dashboard/fetchAssetCount")
            this.$store.dispatch("dashboard/fetchVolunteerCount")
        }
    };
</script>

<style scoped>
/* Same gap below every card, so wrapped/stacked cards are evenly spaced */
.card-col {
    margin-bottom: 16px;
}

.stat-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 16px;
    border-radius: 0.375rem;
    background-color: #fcf0e8;
    color: black;
}

.stat-card--centered {
    justify-content: center;
    align-items: center;
    text-align: center;
}

.title {
    font-size: large;
    font-weight: 500;
    color: #e4701e;
    overflow-wrap: anywhere;
}

.count {
    text-align: end; 
    font-size: xx-large; 
    font-weight: 500; 
    padding-right: 28px;
}

.main-title {
    font-size: x-large; 
    font-weight: 500;
}

@media (max-width: 1480px) {
    .main-title {
        font-size: large; 
        font-weight: 500;
    }
}

@media (max-width: 768px) {
    .count {
       padding-right: 12px;
    }
}
</style>
    